export default "__VITE_ASSET__DVHROaiW__"